var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkflowAttestation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#723DFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.667 8.106v6.72c0 .537 0 .98.03 1.34.03.375.095.72.26 1.043.256.502.664.91 1.166 1.166.323.165.668.23 1.042.26.361.03.804.03 1.34.03h6.99c.536 0 .979 0 1.34-.03.374-.03.719-.095 1.042-.26.502-.256.91-.664 1.166-1.166.165-.323.23-.668.26-1.042.03-.361.03-.804.03-1.34v-2.99c0-.536 0-.979-.03-1.34-.03-.374-.096-.719-.26-1.042a2.667 2.667 0 00-1.166-1.166c-.323-.165-.668-.23-1.043-.26-.36-.03-.803-.03-1.34-.03H13.08l-.597-1.193c-.176-.354-.332-.666-.573-.903a2 2 0 00-.748-.462c-.32-.11-.668-.11-1.063-.109H7.44c-.351 0-.655 0-.904.02-.264.022-.526.07-.778.198a2 2 0 00-.874.874 2.036 2.036 0 00-.198.778c-.02.25-.02.553-.02.904zm6.06-1.404c-.08-.028-.185-.036-.712-.036H7.467c-.385 0-.633 0-.822.015-.18.015-.248.04-.281.057a.667.667 0 00-.291.292c-.017.032-.042.1-.057.28A9.29 9.29 0 006 8h5.588l-.261-.523c-.236-.471-.29-.56-.351-.62a.667.667 0 00-.25-.154zm4.078 5.435a.667.667 0 10-.943-.943l-2.529 2.529-.862-.862a.667.667 0 00-.942.942l1.333 1.334c.26.26.682.26.943 0l3-3z",
    fill: "#fff"
  })));
}
export default SvgIconWorkflowAttestation;